import { useTranslation } from './useTranslation'
import { TranslationKeys } from 'locales/translationKeys'
import reviewsLocales from '../locales/en/reviews.json'
import { Tag } from 'fixtures/review'

export const useReviews = () => {
  const { t } = useTranslation()

  type ReviewType = {
    owner: TranslationKeys
    comment: TranslationKeys
    headline: TranslationKeys
    tag: Tag
  }

  const reviews = reviewsLocales.reviewPage.map(
    (_, index) =>
      ({
        owner: `reviews:reviewPage.${index}.owner`,
        comment: `reviews:reviewPage.${index}.comment`,
        headline: `reviews:reviewPage.${index}.headline`,
        tag: t(`reviews:reviewPage.${index}.tag` as TranslationKeys),
      } as ReviewType)
  )

  return reviews
}
